// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports, no-undef, no-console */
// FIXME: remove this disable directive and fix the ESLint error(s)

// @ts-expect-error: Flow to TS migration.
import _ from "lodash"
import { OrderedSet } from "immutable"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"

import mapperManageBookingChange from "./mapperManageBookingChange"

// @ts-expect-error: Flow to TS migration.
export default function mapperAdditionalServices(input: BookingInput) {
  try {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const details = (input.additional_bookings && input.additional_bookings.details) || []
    // @ts-expect-error: Flow to TS migration.
    const mappedAdditionalBookings = _.map(details, (x) => mapperManageBookingChange(x))

    // @ts-expect-error: Flow to TS migration.
    return new OrderedSet(mappedAdditionalBookings)
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    cuckoo.error(cuckooEvents.MMB_ADDITIONAL_SERVICE_MAPPER_ERROR, { error })
    console.error(error)

    return null
  }
}
